"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParserContext = createParserContext;
function createParserContext(source) {
    return source === "input"
        ? { source, hasSystemMessage: false }
        : { source, toolCallKeys: new Set() };
}
